import { createContext, useState, memo, useCallback } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { GET_POSTS } from '../queries/postQueries';
import { SAVE_POST } from "../mutations/userMutations";

export const PostsContext = createContext()

export const PostsContextProvider = memo(({ children, userId, feedType }) => {
  const [isLoading, setIsLoading] = useState(true)

  const { error, data, refetch } = useQuery(GET_POSTS, {
    variables: { id: userId || '', feedType: feedType || 'posts' },
    onCompleted: () => {
      setIsLoading(false)
    },
    onError: (error) => {
      setIsLoading(false)
      throw new Error(error.message)
    }
  })

  const [savePost] = useMutation(SAVE_POST, {
    onCompleted: async () => {
      await refetch()
    },
    onError: (error) => {
      throw new Error(error.message)
    }
  })

  const refetchPosts = useCallback(async () => {
    setIsLoading(true)

    await refetch()
    
    setIsLoading(false)
  }, [refetch])

  return (
    <PostsContext.Provider value={{ savePost, error, isLoading, data, refetchPosts }}>
      { children }
    </PostsContext.Provider>
  )
})
